import { gql, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { insertQuestions } from '../reducers/graph';
import { InitialQuestionData } from '../types/kb';
import { useSpecialty, useVersion } from './useVersion';

const GET_INITIAL_QUESTIONS_QUERY = gql`
  query InitialQuestions($version: Float!, $specialty: String) {
    initialQuestions(version: $version, specialty: $specialty) {
      extId
      afterConnection {
        edges {
          properties {
            condition
          }
          node {
            extId
          }
        }
      }
    }
  }
`;

export const useInitialQuestions = (forceRefresh?: boolean) => {
  const dispatch = useDispatch();
  const version = useVersion();
  const specialty = useSpecialty();

  useQuery<InitialQuestionData>(GET_INITIAL_QUESTIONS_QUERY, {
    variables: { forceRefresh, specialty, version },
    errorPolicy: 'all',
    skip: !specialty,
    onCompleted: (data) => {
      if (data?.initialQuestions)
        dispatch(
          insertQuestions(
            data.initialQuestions.map((q) => ({
              extId: q.extId,
            })),
          ),
        );
    },
  });
};
